module.exports = __webpack_public_path__ + "images/application/illustrations/templates-c07a2fab.svg";